import { createSelector } from 'reselect';
import { getTravelSsInsurance } from './index';
import { FORM_STATUS, API_CALL_STATUS } from '../../reducers/status';
export const getQuote = createSelector(getTravelSsInsurance, (state) => {
    return state && state.quote;
});

export const getQuoteForm = createSelector(getQuote, (quote) => quote && quote.form);
export const getQuoteFormValid = createSelector(getQuote, (quote) => quote && quote.formStatus === FORM_STATUS.VALID);
export const getPremiumCalculation = createSelector(getQuote, (quote) => quote && quote.premiumCalculation);

export const getSelectedForm = createSelector(getQuote, (quote) => quote.selectedForm);

export const getQuoteFormApiCallStatus = createSelector(getQuote, (quote) => quote && quote.apiCallStatus);
export const getQuoteFormApiCallSuccess = createSelector(
    getQuote,
    (quote) => quote && quote.apiCallStatus === API_CALL_STATUS.SUCCESS
);
export const getQuoteFormApiCallFailure = createSelector(
    getQuote,
    (quote) => quote && quote.apiCallStatus === API_CALL_STATUS.FAILURE
);
export const getIsApiPending = createSelector(
    getQuote,
    (quote) => quote && quote.apiCallStatus === API_CALL_STATUS.PENDING
);

// Nationalities
export const getIsCountriesApiPending = createSelector(
    getQuote,
    (quote) => quote.countriesApiCallStatus === API_CALL_STATUS.PENDING
);

export const getIsUsdRateApiPending = createSelector(
    getQuote,
    (quote) => quote.usdRateApiCallStatus === API_CALL_STATUS.PENDING
);

export const getTotalNoOfTravellers = createSelector(getQuote, (quote) => quote && quote.totalNoOfTravellers);
export const getCountries = createSelector(getQuote, (quote) => quote.countries);
export const getUsdRate = createSelector(getQuote, (quote) => quote.usdRate);
export const getUgxPremium = createSelector(getQuote, (quote) => quote.ugxPremium);
export const getAddedCover = createSelector(getQuote, (quote) => quote && quote.addedCover);
export const getShareModalValue = createSelector(getQuote, (quote) => quote && quote.showShareModal);
export const getShareQuoteAPIStatus = createSelector(getQuote, (quote) => quote && quote.shareQuoteAPIStatus);
export const getShareQuoteFormStatus = createSelector(getQuote, (quote) => quote && quote.shareQuoteFormStatus);
export const getUgCmbObject = createSelector(getQuote, (quote) => quote && quote.ugCmbObject);
export const getIsApiPendingProducts = createSelector(getQuote, (quote) => quote && quote.apiPendingProducts);
export const getProducts = createSelector(getQuote, (quote) => quote && quote.products);
export const getStep = createSelector(getQuote, (quote) => quote && quote.step);

const makeGetFormField = (fieldId) => createSelector(getQuoteForm, (form) => form[fieldId]);

export const getFullName = makeGetFormField('fullName');
export const getPhoneNumberValue = makeGetFormField('phoneNumber');
export const getEmailValue = makeGetFormField('email');
export const getIdNumberValue = makeGetFormField('idNumber');
export const getTripType = makeGetFormField('tripType');
export const getCoverFor = makeGetFormField('coverFor');
export const getAge = makeGetFormField('age');
export const getDepartureCountry = makeGetFormField('departureCountry');
export const getDestinationCountry = makeGetFormField('destinationCountry');
export const getDepatureDate = makeGetFormField('departureDate');
export const getReturnDate = makeGetFormField('returnDate');
export const getNoOfTravellers = makeGetFormField('noOfTravellers');
export const getNoOfMinors = makeGetFormField('noOfMinors');
export const getSelectedCover = makeGetFormField('selectedCover');
export const getShareEmailValue = makeGetFormField('shareEmail');
export const getDob = makeGetFormField('dob');
